export const PROJECT_TYPES = ['Pipeline', 'Fabrication', 'Others'] as const;
export const STATUS_TYPES = ['In Progress', 'Completed', 'On Hold'] as const;
export const PROJECTS_PER_PAGE = 10;

export const STATUS_COLORS = {
  'In Progress': 'bg-blue-100 text-blue-800',
  'Completed': 'bg-green-100 text-green-800',
  'On Hold': 'bg-yellow-100 text-yellow-800',
  'default': 'bg-gray-100 text-gray-800'
} as const; 